import { concatStyleSets, mergeStyles } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react";
import { flexParent, flexParentCenterCrossAxis } from "../../../utilities/Mixin.styles";
/** Get the CSS styles for each class the control will use */ export const getStyles = memoizeFunction((theme, customStyles)=>{
    const agentStatusIndicatorStyle = [
        flexParent(),
        flexParentCenterCrossAxis
    ];
    const agentStatusIndicatorImageStyle = {
        height: "15px",
        width: "16px",
        marginRight: "10px",
        marginLeft: "12px"
    };
    const styles = {
        agentStatusIndicatorStyle,
        agentStatusIndicatorImageStyle
    };
    return concatStyleSets(styles, customStyles);
});
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        agentStatusIndicatorImageStyle: mergeStyles("agentStatusIndicatorImageStyle", styles.agentStatusIndicatorImageStyle),
        agentStatusIndicatorStyle: mergeStyles("agentStatusIndicatorStyle", styles.agentStatusIndicatorStyle)
    }));
